import React from 'react';

function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className='footer'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12 col-md-6 col-lg-6 text-center text-md-start'>
                        <div>{currentYear} © <span className='super-admin-text'> Hire a Vendor. All rights reserved.
                        </span></div>
                    </div>
                    <div className='col-12 col-md-6  col-lg-6'>
                        <div className='d-none d-md-flex gap-4 align-items-center justify-content-md-end'>
                            <p className='mb-0'>Design & Develop by <a href='https://sdreatech.com' target='_blank' rel='noopener noreferrer' className='super-admin-text'>Sdreatech</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
